import { BaseModel, PhoneNumber } from '@red/data-access';
import { Expose, Type } from 'class-transformer';
import { EBuyerType, EBuyerPropertyType } from '../enums/buyer.enum';
import { ECitizen } from '../enums/citizen.enum';
import { EGender } from '../enums/gender.enum';
import { ENumberOf } from '../enums/number-of.enum';
import { EPurpose } from '../enums/purpose.enum';
import { IBlankFormBuyerDto } from '../interfaces/blank-form-buyer.interface';
import { AddressBuyerDto } from './address.dto';

export class BlankFormBuyerDto extends BaseModel implements IBlankFormBuyerDto {
  @Expose()
  @Type(() => Number)
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  type!: EBuyerType;

  @Expose()
  gender!: EGender;

  @Expose()
  maritalId!: number;

  @Expose()
  propertyType!: EBuyerPropertyType;

  @Expose()
  categoryId!: number;

  @Expose()
  postal!: string;

  @Expose()
  nricNo!: string;

  @Expose()
  yearOfBirth!: number;

  @Expose()
  @Type(() => AddressBuyerDto)
  address!: AddressBuyerDto;

  @Expose()
  email!: string;

  @Expose()
  @Type(() => PhoneNumber)
  mobile!: PhoneNumber;

  @Expose()
  citizen!: ECitizen;

  @Expose()
  nationalityId!: number;

  @Expose()
  nationality!: string;

  @Expose()
  districtId!: number;

  @Expose()
  occupation!: string;

  @Expose()
  ownership!: ENumberOf;

  @Expose()
  isHdbOwnership!: number;

  @Expose()
  purposeOfPurchase!: EPurpose;

  @Expose()
  attrs!: any;
}
